import React from 'react';
import { Grid, CircularProgress } from '@material-ui/core';
import { FasUndoAlt, FasSave } from 'assets/icons';
import molecules from 'ctsutheme/components/molecules';
import atoms from 'ctsutheme/components/atoms';

const { CardActions } = molecules;
const { Button, Icon } = atoms;

export const CTSUCardActions = ({
  disabled,
  clearClick,
  cancelClick,
  disableSave,
  hideCancel,
  save,
  saveText,
  clearTitle
}) => (
  <CardActions>
    <Grid
      container
      spacing={3}
    >
      <Grid
        xs={4}
        item
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
      >
        {/* {!disabled && (
        <Button
          size="small"
          variant="outlined"
          name="clearStatus"
          onClick={clearClick}
          disabled={disabled}
          className="turquoise whiteSpace-nowrap"
        >
          <Icon style={{ fontSize: 20 }} className="mr-1">
            <FasUndoAlt />
          </Icon>
          Clear Changes
        </Button>
        )} */}
      </Grid>
      <Grid
        item
        xs={8}
        container
        direction="row"
        justify="flex-end"
        alignItems="center"
      >
        {!disabled && (
        <Button
          data-testid="test-clear-btn"
          size="small"
          variant="outlined"
          title={clearTitle || 'Clear changes'}
          name="clearStatus"
          onClick={clearClick}
          disabled={disabled}
          className="fn-btn color-dark-blue whiteSpace-nowrap mb-1"
        >
          <Icon style={{ fontSize: 20 }} className="mt-n1">
            <FasUndoAlt />
          </Icon>
          Clear Changes
        </Button>
        )}
        {save && <CircularProgress size={24} />}
        {!disabled && (
          <Button
            data-testid="test-save-btn"
            className="turquoise ml-1 mb-1"
            variant="outlined"
            name="saveStatus"
            type="submit"
            title={saveText || 'Save Changes'}
            disabled={disabled || disableSave}
          >
            <Icon className="mr-1">
              <FasSave />
            </Icon>
            {saveText || 'Save Changes'}
          </Button>
        )}
        {
          (hideCancel === 'show') ? '' : (
            <Button
              variant="outlined"
              className="turquoise close ml-1"
              onClick={cancelClick}
            >
              Close
            </Button>
          ) 
        }
        
      </Grid>
    </Grid>
  </CardActions>
);